import * as React from "react"
import { Link } from "gatsby"

import { CgSearch, CgShoppingCart } from "react-icons/cg"

const TopBar = () => (
  <div className="topBar level is-mobile m-0">
    <div className="level-left">
      <div className="level-item px-4 py-2">
        <Link className="has-text-weight-medium" to="/pages/dates-for-shipping/">When will it arrive?</Link>
      </div>
    </div>
    <div className="level-right">
      {/*<div className="level-item px-4 py-2">
        <Link to="/account/login/">
          <span className="px-2" role="img" aria-label="login">
            👤
          </span>
          Login
        </Link>
      </div>*/}
      <div className="level-item px-5 py-2">
        <Link to="/search/">
          <span role="img" aria-label="search">
            <CgSearch />
          </span>
        </Link>
      </div>
      <div className="cartContainer level-item px-5 py-2">
        <Link to="/cart/">
          <span role="img" aria-label="cart">
            <CgShoppingCart />
          </span>
        </Link>
      </div>
    </div>
  </div>

)

export default TopBar
